import { hasOnlyLetters } from '@/utils/validates';
import { strongPasswordValidation } from '@/validators/password';
import * as yup from 'yup';

export const resetName = yup.object().shape({
  name: yup
    .string()
    .required('Informe um nome')
    .max(80, 'O nome não pode ter mais de 80 caracteres.')
    .test(
      'hasOnlyLetters',
      'Nome não pode conter números ou caracteres especiais',
      value => !!value?.match(hasOnlyLetters)
    ),
});

export const resetEmail = yup.object().shape({
  email: yup
    .string()
    .required('Informe um email!')
    .max(200, 'O seu email não pode ter mais de 200 caracteres!')
    .email('Insira um email válido'),
});

export const resetAlternativeEmail = yup.object().shape({
  alternative_email: yup
    .string()
    .required('Informe um email alternativo!')
    .max(200, 'O seu email alternativo não pode ter mais de 200 caracteres!')
    .email('Insira um email alternativo válido'),
});

export const resetDisplayName = yup.object().shape({
  display_name: yup
    .string()
    .required('Informe um apelido')
    .max(80, 'O apelido não pode ter mais de 80 caracteres.'),
});

export const resetSocialMedia = yup.object().shape({
  facebook_url: yup
    .string()
    .nullable()
    .max(200, 'O link não pode ter mais de 200 caracteres!'),
  instagram_url: yup
    .string()
    .nullable()
    .max(200, 'O link não pode ter mais de 200 caracteres!'),
  linkedin_url: yup
    .string()
    .nullable()
    .max(200, 'O link não pode ter mais de 200 caracteres!'),
});

export const resetPassword = yup
  .object()
  .shape({
    current_password: yup.string().required('Digite sua senha atual'),
    re_new_password: yup
      .string()
      .required('Confirme sua nova senha')
      .oneOf([yup.ref('password'), null], 'As senhas informadas não coincidem'),
  })
  .concat(strongPasswordValidation);
